import { type BaseQueryFn } from '@reduxjs/toolkit/query';
import { type AxiosRequestConfig, type AxiosError } from 'axios';

import axios from './axios';

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '/web' },
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      data?: unknown;
      params?: Record<string, unknown>;
      headers?: Record<string, string>;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const config: AxiosRequestConfig = {
        url: baseUrl + url,
        method,
        ...(data !== undefined && { data }),
        ...(params !== undefined && { params }),
        ...(headers !== undefined && { headers }),
      };
      const result = await axios(config);
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,

          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
